import { tv } from 'tailwind-variants';

// Tailwind variants for the ProgressBar component (Default skin)
export const defaultVariants = tv({
  slots: {
    wrapper: ['flex flex-col p-6 md:p-12 border-3 border-light-gray border-t-secondary'],
    header: [
      'flex flex-row flex-wrap justify-between items-start gap-x-7.5',
      'md:flex-col md:gap-0',
    ],
    headerText: ['flex flex-col flex-auto mb-4 md:w-full'],
    title: ['text-light-black text-2xl font-bold leading-normal'],
    lastUpdated: ['text-light-black text-[1.125rem] font-medium md:font-light leading-normal'],
    percentageWrapper: ['flex justify-end basis-0 grow md:w-full'],
    percentage: ['text-textPrimary text-5xl md:text-7xl font-black leading-none'],
    track: ['w-full h-4 border border-light-black'],
    fill: ['h-full'],
  },
});
